import { useDialogStore } from '@/store/dialogStore'
import { useI18n } from 'vue-i18n'

export function useDialog () {
  const { setDialog } = useDialogStore()

  const { t } = useI18n()

  const alertDialog = ({
    title,
    description,
    confirmLabel
  }: {
    title: string,
    description: string,
    confirmLabel?: string
  }): Promise<boolean> => {
    return new Promise((resolve) => {
      setDialog({
        type: 'alert',
        title,
        description,
        buttonDir: 'col',
        confirmLabel: confirmLabel ?? t('confirm'),
        cancelLabel: '',
        _resolver: resolve
      })
    })
  }

  const confirmDialog = ({
    title,
    description,
    confirmLabel,
    cancelLabel,
    buttonDir
  }: {
    title: string,
    description: string,
    confirmLabel?: string,
    cancelLabel?: string,
    buttonDir?: 'row' | 'col'
  }): Promise<boolean> => {
    return new Promise((resolve) => {
      setDialog({
        type: 'confirm',
        title,
        description,
        confirmLabel: confirmLabel ?? t('confirm'),
        cancelLabel: cancelLabel ?? t('cancel'),
        buttonDir: buttonDir ?? 'col',
        _resolver: resolve
      })
    })
  }

  return {
    alertDialog,
    confirmDialog
  }
}
